export default __webpack_public_path__ + "static/media/vendas.8e0d8064.svg";